<template>
  <div id="app" class="content" v-cloak>
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  name: "App",
  components: {
    Header,
    Footer
  },
  watch: {
    $route(to) {
      document.title = `${to.meta.title} | Post Office` || "Post Office";
    }
  }
};
</script>

<style scoped>
.content {
  top: 4vh;
  @apply relative;
}

@screen sm {
  .content {
    top: 120px;
  }
}
</style>
